/**
 * @module
 *
 * @import {Controller} from '@acng/frontend-stargazer';
 */
import {COMPILE} from '@acng/frontend-stargazer';
import {BOOLEAN, guard} from '@acng/frontend-rubicon';
import {popup} from '@acng/frontend-discovery';
import {RemoveController, MailFormController} from 'nova';

import {get, post} from '../../core/service/backend.js';
import {getLocalOverlay} from '../../core/service/overlay.js';
import {t} from '../../locale/config/translate.js';

/**
 * @example
 *
 * ```html
 * <!--@ ${auth.signup.confirm} -->
 * <form>
 *   <input name="email" />
 *   <input type="submit" />
 * </form>
 * ```
 *
 * @implements {Controller}
 */
class ConfirmMail extends MailFormController {
  enabled = new RemoveController(true);
  disabled = new RemoveController(false);

  /**
   * @param {Element} form
   */
  async [COMPILE](form) {
    super[COMPILE](form);

    const alreadySent = await get('user/requested-confirm-mail');
    ASSERT: guard(alreadySent, BOOLEAN);

    if (alreadySent) {
      this.#disable();
    }
  }

  /**
   * @param {HTMLFormElement} form
   * @param {FormData} data
   */
  async submit(form, data) {
    try {
      await post('user/send-confirm-mail', data, form, async (error) => {
        if (error.data.code == 5004) {
          this.#disable();

          return null;
        }

        throw error;
      });

      await popup(form).info(await t('userPool.confirmationMailSent'));
      form.reset();
      getLocalOverlay(form)?.close();
    } catch (e) {
      // all handled by core/service/backend
    }
  }

  #disable() {
    this.enabled.condition = false;
    this.disabled.condition = true;
  }
}

export {ConfirmMail};
